export default __webpack_public_path__ + "static/media/cowhiceChair.52d8515d.png";